// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table td {
  vertical-align: middle !important;
}

.back {
  font-size: 16px;
  font-weight: 500;
}
.event-img-view {
  width: 60px;
  height: 60px;
  margin-left:7px;
  margin-right: 5px;
}
.accomdation-modal .MuiBox-root:focus-within {
  outline: none !important;
}

.searchc {
  width: 100%;
  padding: 8px 10px;
  margin-right: -4px;
  outline: none;
  border-width: 0px;
  border-radius: 5px;
}

.register-eventEdit {
  width: 100%;
  background-color: white;
  border-radius: 4px;
  padding: 1px 10px 20px 10px;
  margin-bottom: 32px;
  margin-top: 20px !important;
}

.view-header {
  background-color: #ffffff;
  border: 1.89372px solid rgba(140, 174, 120, 0.12);
  padding: 1% 12% 0.5%;
}
.rounded-top {
  background-color: #eaeaea;
}
.AccomodationHeader {
  background: #ffffff;
  box-shadow: 0px 15px 28px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}

.view-body {
  padding: 0% 12% 5%;
}

.edit-Print {
  color: #68ad3f;
  font-weight: 500;
  font-size: 16px;
  cursor: pointer;
}
.login-ft-btnclosed {
  font-size: 16px;
  font-weight: 500;
  background-color: transparent;
  border-radius: 4px;
  color: #68ad3f;
  border: 1px solid #68ad3f;
  width: auto;
  height: 42px;
}
.editArrow {
  margin-left: 13px !important;
}
.signup-btnclosed {
  margin: 0px 12px;
  font-weight: 500;
  background-color: transparent;
  border-radius: 4px;
  color: #68ad3f;
  border: 1px solid #68ad3f;
  width: auto;
  height: 42px;
}

.EditCompS {
  border: 2px solid #68ad3f !important;
  border-radius: 4px !important;
  width: auto !important;
}
.register-eventsforClosed {
  width: 100%;
  box-shadow: 0px 15px 42px rgba(0, 0, 0, 0.05);
  background-color: white;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 7px 20px;
  margin-bottom: 40px;
  margin-top: 20px;
  cursor: pointer;
  box-sizing: border-box;
  width: 312px;
  height: 63px !important;
  background: #ffffff;
  border-radius: 4px;
  flex: none;
  order: 0;
  flex-grow: 0;
  height: auto;
  justify-content: center;
}
.registerdancerforclosed {
  font-weight: 500;
  font-size: 22px;
  margin-top: 4px;
  color: #424242;
}
.editGradeLvlcls {
  font-weight: 500;
  font-size: 12px;
  opacity: 0.3;
}

.css-s9a7ft-MuiButtonBase-root-MuiButton-root {
  width: auto !important;
}
.EditComp {
  border: 3px solid;
}

.iframe-view {
  width: 100%;
  height: 30vh;
}

.reg-details {
  margin-right: 10px;
}

.adjudicator {
  display: flex;
  padding: 0 0 12px 0;
}
.adjudicatorDescription {
  padding: 12px 0px 0px 8px;
  font-weight: 400px !important;
}

.web-btn {
  font-weight: 500;
  font-size: 16px;
  text-align: center;
  color: #68ad3f;
}
.web-btn-edit {
  font-weight: 500;
  font-size: 16px;
  text-align: center;
  color: #68ad3f;
  cursor:pointer;
}

.Adjudicators {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.register-eventss {
  height: 150px;
  width: 100%;
  box-shadow: 0px 15px 42px rgba(0, 0, 0, 0.05);
  background-color: white;
  border-radius: 4px;
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
  padding: 20px;
  margin-bottom: 40px;
}

.location-Details {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #2d2d2d;
  text-transform: capitalize;
  margin: 0 !important;
}
.adjudicatorDescription h6 {
  color: #424242;
}
.adjudicatorDescription h6,
.adjudicatorDescription p {
  padding: 0;
  margin: 0;
}

.leftBlock {
  height: 90vh;
  overflow-y: scroll;
}

.leftBlock::-webkit-scrollbar {
  display: none;
}

.registerweb-events-list {
  display: flex;
  align-items: center;
  width: 70%;
  flex-grow: 1;
}

.editGrades {
  background-color: #797979;
  width: fit-content;
  padding: 2px 6px;
  color: white;
  font-size: 14px;
  font-weight: 400;
  border-radius: 4px;
  margin-bottom: 3px;
}
.boxScroll::-webkit-scrollbar {
  display: none !important; /* Safari and Chrome */
}
.editGradeLvl {
  font-weight: 500;
  font-size: 12px;
  color: #fbb040;
  opacity: 0.6;
}

.tableCount {
  background-color: #fbb040;
  padding: 0 6px;
  font-size: 16px;
  color: white;
  font-weight: 400;
  border-radius: 4px;
}

.eventGradename {
  font-weight: 400;
  font-size: 16px;
  display: flex;
  align-items: center;
  color: #424242;
}

.registerevent-mobile-div {
  display: flex;
}

p.reg-date {
  padding-left: 0px;
}

.pageHeaders {
  margin-top: 20px;
  margin-bottom: 5px;
  color: #424242;
  font-weight: 500;
  font-size: 22px;
}
.editComps {
  padding: 4px !important;
}
.editComps {
  padding: 8px 16px !important;
}
.my_table {
  border-collapse: separate;
  border-spacing: 0;
  border-top: 1px solid grey;
  border-right: 1px solid grey;
  border-left: 1px solid grey;
  border-radius: 4px;
  -moz-border-radius: 4px;
  -webkit-border-radius: 4px;
}

.my_table tr:first-of-type td:first-of-type {
  border-top-left-radius: 4px;
}

.my_table tr:first-of-type td:last-of-type {
  border-top-right-radius: 4px;
}

.my_table tr:last-of-type td:first-of-type {
  border-bottom-left-radius: 4px;
}

.my_table tr:last-of-type td:last-of-type {
  border-bottom-right-radius: 4px;
}
/*  <---------------------------- media query for mpbile devices ------------------------------------->   */
@media only screen and (min-width: 0px) and (max-width: 481px) {
  .edit-Print {
    font-size: 11px;
  }
  .EditComp {
    font-size: 11px !important;
  }

  .EditCompS {
    font-size: 11px !important;
    padding: 2px !important;
  }
}
@media only screen and (min-width: 0px) and (max-width: 767px) {

  .web-btn-edit,.delete-btn-dancer,.eventGradename {
    font-size: 12px;
  }
  .editGrades,.editGradeLvl {
    font-size: 10px;
  }
  .back {
    margin-top: 1.65px;
  }
  .competitorTable {
    width: 1100px !important;
  }

  .adjudicator {
    padding: 1vh 0vh 1vh 0vh;
  }

  .Adjudicators {
    display: block;
  }

  .leftBlock {
    height: max-content;
    overflow-y: none;
  }

  .registerweb-events-list {
    display: none;
  }

  img.event-img {
    height: 70px;
    width: 70px;
    padding: 0px;
  }

  .reg-close {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #eaeaea;
    width: 100%;
    padding: 20px 20px 0px 20px;
  }

  .reg-date-close {
    text-align: left;
  }

  .header-mobile {
    flex-direction: column;
  }

  .view-body {
    padding: 2% 9%;
  }

  .view-header {
    padding: 1% 5% 0.5%;
  }
}

.description {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: justify;
  color: #2d2d2d;
  font-family: Rubik;
}
pre {
  white-space: pre-wrap;
}

@media only screen and (min-width: 481px) and (max-width: 786px) {
  .Adjudicators {
    display: flex;
  }
}

/*  <---------------------------- media query for mpbile devices landscape orientation ------------------------------------->  */
@media (max-width: 561px) {
  .adjudicator {
    padding: 1vh 0vh 1vh 0vh;
  }

  .Adjudicators {
    display: block;
  }

  .leftBlock .adjudicatorCard {
    width: 100% !important;
  }

  .view-btn {
    width: 120px !important;
  }
}

@media (min-width: 561px) {
  .adjudicator {
    width: 48.5%;
  }
}

/*  <---------------------------- media query for ipad devices ------------------------------------->  */

@media only screen and (min-width: 768px) and (max-width: 980px) {
  .adjudicator {
    display: flex;
    padding: 0 8px 8px 0px;
  }

  .view-body {
    padding: 2% 5%;
  }

  .view-header {
    padding: 1% 5% 0.5% !important;
  }

  .registerevent-details {
    width: 279px;
  }
  .registerevent-details-edit {
    width: 250px;
  }
  .competitorTable {
    width: 1100px !important;
  }
  .web-btn-edit{
    font-size: 12px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 980px) {
  .registerevent-details-edit {
    width: 300px;
  }
}
/*  <---------------------------- media query for ipad pro devices ------------------------------------->  */
@media only screen and (min-width: 981px) and (max-width: 1199px) {
  .adjudicator {
    display: flex;
    padding: 1vh;
  }

  .Adjudicators {
    display: flex;
  }
  .registerevent-details {
    width: 397px;
  }
  .registerevent-details-edit {
    width: 300px;
  }
  .competitorTable {
    width: 1100px !important;
  }
}

/*  <---------------------------- media query for large screens ------------------------------------->  */
@media only screen and (min-width: 1200px) and (max-width: 1399px) {
  .registerevent-details {
    width: 75%;
    flex-grow: 1;
  }
  .registerevent-details-edit {
    width: 500px;
  }
}
@media screen and (min-width: 1200px) {
  .eventGradename {
    font-weight: 400;
    font-size: 18px;
    display: flex;
    align-items: center;
    color: #424242;
  }
}

`, "",{"version":3,"sources":["webpack://./src/Parent/Register-Events/Edit-Event/style.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,iDAAiD;EACjD,oBAAoB;AACtB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,6CAA6C;EAC7C,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,6CAA6C;EAC7C,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,0BAA0B;EAC1B,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EAEzB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,wBAAwB,EAAE,sBAAsB;AAClD;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;AACA,2GAA2G;AAC3G;EACE;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,uBAAuB;EACzB;AACF;AACA;;EAEE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,6BAA6B;IAC7B,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,gIAAgI;AAChI;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA,wGAAwG;;AAExG;EACE;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA,4GAA4G;AAC5G;EACE;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA,yGAAyG;AACzG;EACE;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,cAAc;EAChB;AACF","sourcesContent":[".table td {\n  vertical-align: middle !important;\n}\n\n.back {\n  font-size: 16px;\n  font-weight: 500;\n}\n.event-img-view {\n  width: 60px;\n  height: 60px;\n  margin-left:7px;\n  margin-right: 5px;\n}\n.accomdation-modal .MuiBox-root:focus-within {\n  outline: none !important;\n}\n\n.searchc {\n  width: 100%;\n  padding: 8px 10px;\n  margin-right: -4px;\n  outline: none;\n  border-width: 0px;\n  border-radius: 5px;\n}\n\n.register-eventEdit {\n  width: 100%;\n  background-color: white;\n  border-radius: 4px;\n  padding: 1px 10px 20px 10px;\n  margin-bottom: 32px;\n  margin-top: 20px !important;\n}\n\n.view-header {\n  background-color: #ffffff;\n  border: 1.89372px solid rgba(140, 174, 120, 0.12);\n  padding: 1% 12% 0.5%;\n}\n.rounded-top {\n  background-color: #eaeaea;\n}\n.AccomodationHeader {\n  background: #ffffff;\n  box-shadow: 0px 15px 28px rgba(0, 0, 0, 0.05);\n  border-radius: 4px;\n}\n\n.view-body {\n  padding: 0% 12% 5%;\n}\n\n.edit-Print {\n  color: #68ad3f;\n  font-weight: 500;\n  font-size: 16px;\n  cursor: pointer;\n}\n.login-ft-btnclosed {\n  font-size: 16px;\n  font-weight: 500;\n  background-color: transparent;\n  border-radius: 4px;\n  color: #68ad3f;\n  border: 1px solid #68ad3f;\n  width: auto;\n  height: 42px;\n}\n.editArrow {\n  margin-left: 13px !important;\n}\n.signup-btnclosed {\n  margin: 0px 12px;\n  font-weight: 500;\n  background-color: transparent;\n  border-radius: 4px;\n  color: #68ad3f;\n  border: 1px solid #68ad3f;\n  width: auto;\n  height: 42px;\n}\n\n.EditCompS {\n  border: 2px solid #68ad3f !important;\n  border-radius: 4px !important;\n  width: auto !important;\n}\n.register-eventsforClosed {\n  width: 100%;\n  box-shadow: 0px 15px 42px rgba(0, 0, 0, 0.05);\n  background-color: white;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  padding: 7px 20px;\n  margin-bottom: 40px;\n  margin-top: 20px;\n  cursor: pointer;\n  box-sizing: border-box;\n  width: 312px;\n  height: 63px !important;\n  background: #ffffff;\n  border-radius: 4px;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n  height: auto;\n  justify-content: center;\n}\n.registerdancerforclosed {\n  font-weight: 500;\n  font-size: 22px;\n  margin-top: 4px;\n  color: #424242;\n}\n.editGradeLvlcls {\n  font-weight: 500;\n  font-size: 12px;\n  opacity: 0.3;\n}\n\n.css-s9a7ft-MuiButtonBase-root-MuiButton-root {\n  width: auto !important;\n}\n.EditComp {\n  border: 3px solid;\n}\n\n.iframe-view {\n  width: 100%;\n  height: 30vh;\n}\n\n.reg-details {\n  margin-right: 10px;\n}\n\n.adjudicator {\n  display: flex;\n  padding: 0 0 12px 0;\n}\n.adjudicatorDescription {\n  padding: 12px 0px 0px 8px;\n  font-weight: 400px !important;\n}\n\n.web-btn {\n  font-weight: 500;\n  font-size: 16px;\n  text-align: center;\n  color: #68ad3f;\n}\n.web-btn-edit {\n  font-weight: 500;\n  font-size: 16px;\n  text-align: center;\n  color: #68ad3f;\n  cursor:pointer;\n}\n\n.Adjudicators {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n\n.register-eventss {\n  height: 150px;\n  width: 100%;\n  box-shadow: 0px 15px 42px rgba(0, 0, 0, 0.05);\n  background-color: white;\n  border-radius: 4px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-around;\n  padding: 20px;\n  margin-bottom: 40px;\n}\n\n.location-Details {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: #2d2d2d;\n  text-transform: capitalize;\n  margin: 0 !important;\n}\n.adjudicatorDescription h6 {\n  color: #424242;\n}\n.adjudicatorDescription h6,\n.adjudicatorDescription p {\n  padding: 0;\n  margin: 0;\n}\n\n.leftBlock {\n  height: 90vh;\n  overflow-y: scroll;\n}\n\n.leftBlock::-webkit-scrollbar {\n  display: none;\n}\n\n.registerweb-events-list {\n  display: flex;\n  align-items: center;\n  width: 70%;\n  flex-grow: 1;\n}\n\n.editGrades {\n  background-color: #797979;\n  width: -moz-fit-content;\n  width: fit-content;\n  padding: 2px 6px;\n  color: white;\n  font-size: 14px;\n  font-weight: 400;\n  border-radius: 4px;\n  margin-bottom: 3px;\n}\n.boxScroll::-webkit-scrollbar {\n  display: none !important; /* Safari and Chrome */\n}\n.editGradeLvl {\n  font-weight: 500;\n  font-size: 12px;\n  color: #fbb040;\n  opacity: 0.6;\n}\n\n.tableCount {\n  background-color: #fbb040;\n  padding: 0 6px;\n  font-size: 16px;\n  color: white;\n  font-weight: 400;\n  border-radius: 4px;\n}\n\n.eventGradename {\n  font-weight: 400;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  color: #424242;\n}\n\n.registerevent-mobile-div {\n  display: flex;\n}\n\np.reg-date {\n  padding-left: 0px;\n}\n\n.pageHeaders {\n  margin-top: 20px;\n  margin-bottom: 5px;\n  color: #424242;\n  font-weight: 500;\n  font-size: 22px;\n}\n.editComps {\n  padding: 4px !important;\n}\n.editComps {\n  padding: 8px 16px !important;\n}\n.my_table {\n  border-collapse: separate;\n  border-spacing: 0;\n  border-top: 1px solid grey;\n  border-right: 1px solid grey;\n  border-left: 1px solid grey;\n  border-radius: 4px;\n  -moz-border-radius: 4px;\n  -webkit-border-radius: 4px;\n}\n\n.my_table tr:first-of-type td:first-of-type {\n  border-top-left-radius: 4px;\n}\n\n.my_table tr:first-of-type td:last-of-type {\n  border-top-right-radius: 4px;\n}\n\n.my_table tr:last-of-type td:first-of-type {\n  border-bottom-left-radius: 4px;\n}\n\n.my_table tr:last-of-type td:last-of-type {\n  border-bottom-right-radius: 4px;\n}\n/*  <---------------------------- media query for mpbile devices ------------------------------------->   */\n@media only screen and (min-width: 0px) and (max-width: 481px) {\n  .edit-Print {\n    font-size: 11px;\n  }\n  .EditComp {\n    font-size: 11px !important;\n  }\n\n  .EditCompS {\n    font-size: 11px !important;\n    padding: 2px !important;\n  }\n}\n@media only screen and (min-width: 0px) and (max-width: 767px) {\n\n  .web-btn-edit,.delete-btn-dancer,.eventGradename {\n    font-size: 12px;\n  }\n  .editGrades,.editGradeLvl {\n    font-size: 10px;\n  }\n  .back {\n    margin-top: 1.65px;\n  }\n  .competitorTable {\n    width: 1100px !important;\n  }\n\n  .adjudicator {\n    padding: 1vh 0vh 1vh 0vh;\n  }\n\n  .Adjudicators {\n    display: block;\n  }\n\n  .leftBlock {\n    height: max-content;\n    overflow-y: none;\n  }\n\n  .registerweb-events-list {\n    display: none;\n  }\n\n  img.event-img {\n    height: 70px;\n    width: 70px;\n    padding: 0px;\n  }\n\n  .reg-close {\n    display: flex;\n    justify-content: space-between;\n    border-top: 1px solid #eaeaea;\n    width: 100%;\n    padding: 20px 20px 0px 20px;\n  }\n\n  .reg-date-close {\n    text-align: left;\n  }\n\n  .header-mobile {\n    flex-direction: column;\n  }\n\n  .view-body {\n    padding: 2% 9%;\n  }\n\n  .view-header {\n    padding: 1% 5% 0.5%;\n  }\n}\n\n.description {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: justify;\n  color: #2d2d2d;\n  font-family: Rubik;\n}\npre {\n  white-space: pre-wrap;\n}\n\n@media only screen and (min-width: 481px) and (max-width: 786px) {\n  .Adjudicators {\n    display: flex;\n  }\n}\n\n/*  <---------------------------- media query for mpbile devices landscape orientation ------------------------------------->  */\n@media (max-width: 561px) {\n  .adjudicator {\n    padding: 1vh 0vh 1vh 0vh;\n  }\n\n  .Adjudicators {\n    display: block;\n  }\n\n  .leftBlock .adjudicatorCard {\n    width: 100% !important;\n  }\n\n  .view-btn {\n    width: 120px !important;\n  }\n}\n\n@media (min-width: 561px) {\n  .adjudicator {\n    width: 48.5%;\n  }\n}\n\n/*  <---------------------------- media query for ipad devices ------------------------------------->  */\n\n@media only screen and (min-width: 768px) and (max-width: 980px) {\n  .adjudicator {\n    display: flex;\n    padding: 0 8px 8px 0px;\n  }\n\n  .view-body {\n    padding: 2% 5%;\n  }\n\n  .view-header {\n    padding: 1% 5% 0.5% !important;\n  }\n\n  .registerevent-details {\n    width: 279px;\n  }\n  .registerevent-details-edit {\n    width: 250px;\n  }\n  .competitorTable {\n    width: 1100px !important;\n  }\n  .web-btn-edit{\n    font-size: 12px;\n  }\n}\n@media only screen and (min-width: 768px) and (max-width: 980px) {\n  .registerevent-details-edit {\n    width: 300px;\n  }\n}\n/*  <---------------------------- media query for ipad pro devices ------------------------------------->  */\n@media only screen and (min-width: 981px) and (max-width: 1199px) {\n  .adjudicator {\n    display: flex;\n    padding: 1vh;\n  }\n\n  .Adjudicators {\n    display: flex;\n  }\n  .registerevent-details {\n    width: 397px;\n  }\n  .registerevent-details-edit {\n    width: 300px;\n  }\n  .competitorTable {\n    width: 1100px !important;\n  }\n}\n\n/*  <---------------------------- media query for large screens ------------------------------------->  */\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n  .registerevent-details {\n    width: 75%;\n    flex-grow: 1;\n  }\n  .registerevent-details-edit {\n    width: 500px;\n  }\n}\n@media screen and (min-width: 1200px) {\n  .eventGradename {\n    font-weight: 400;\n    font-size: 18px;\n    display: flex;\n    align-items: center;\n    color: #424242;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
